// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"73c414df","439":"204d211e","576":"4f5393f6","880":"6cc7cef5"}[chunkId] + ".chunk.css";
};